import { getCookie, setCookie } from "./cookie";
import { log } from "./config";
import { generateUUID } from "./utils";

const CLIENT_ID_KEY = "_mai_cid";
const CLIENT_ID_MAX_AGE = 2 * 365 * 24 * 60 * 60; // 2 年（秒）

let cachedClientId: string | null = null;

/** 获取或创建匿名用户 ID */
export function getOrCreateClientId(): string {
  if (cachedClientId) return cachedClientId;

  const existing = getCookie(CLIENT_ID_KEY);
  if (existing) {
    cachedClientId = existing;
    log("Client ID from cookie:", cachedClientId);
    return cachedClientId;
  }

  cachedClientId = generateUUID();
  setCookie(CLIENT_ID_KEY, cachedClientId, CLIENT_ID_MAX_AGE);
  log("New client ID generated:", cachedClientId);
  return cachedClientId;
}
